// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1YQL7","inputWrap":"styles_inputWrap__3p2QT","input":"styles_input__3aTIl"};